export const daysofweek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const dayOfWeekNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const monthsofYear = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const datas = [
  {
    2024: [
      {
        id: 1,
        title: "Project Kickoff Meeting",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit.",
        date: "20",
        month: "8",
        time: "10:00 AM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 2,
        title: "Team Building Activity",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "22",
        month: "8",
        time: "02:00 PM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 3,
        title: "15 August",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "15",
        month: "7",
        time: "11:00 AM",
        image:
          "https://media.istockphoto.com/id/1404167377/vector/5th-august-india-independence-day-indian-flag.jpg?s=612x612&w=0&k=20&c=pgELixGuGU2M9zXc5Uyyy0ALegE8BMIHUmaov3Ulh2g=",
      },
      {
        id: 4,
        title: "Raksha bandhan",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit.",
        date: "19",
        month: "7",
        time: "09:00 AM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 5,
        title: "Code Review Session",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "30",
        month: "8",
        time: "03:00 PM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 6,
        title: "Design Workshop",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "5",
        month: "9",
        time: "01:00 PM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 7,
        title: "Sprint Planning",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "12",
        month: "9",
        time: "10:00 AM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
    ],
  },

  {
    2025: [
      {
        id: 1,
        title: "Project management",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "20",
        month: "8",
        time: "10:00 AM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 2,
        title: "Team Building Activity and sports",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "22",
        month: "8",
        time: "02:00 PM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 3,
        title: "15 August",
        description: "vLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "15",
        month: "7",
        time: "11:00 AM",
        image:
          "https://media.istockphoto.com/id/1404167377/vector/5th-august-india-independence-day-indian-flag.jpg?s=612x612&w=0&k=20&c=pgELixGuGU2M9zXc5Uyyy0ALegE8BMIHUmaov3Ulh2g=",
      },
      {
        id: 4,
        title: "Raksha bandhan",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet nisi at elit venenatis fringilla. Cras ut semper quam, sit..",
        date: "19",
        month: "8",
        time: "09:00 AM",
        image:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900",
      },
      {
        id: 5,
        title: "Coding",
        description:
          "https://imgk.timesnownews.com/story/Happy_Raksha_Bandhan_greetings.jpg?tr=w-1200,h-900.",
        date: "30",
        month: "8",
        time: "03:00 PM",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScJJTCPnf4nmexPC2_pr25jQaN7eNINybeeg&s",
      },
      {
        id: 6,
        title: "ui Design Workshop",
        description: "Workshop to discuss the new design principles.",
        date: "5",
        month: "9",
        time: "01:00 PM",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJsjhsNndnmxR2eNf2s4UaTUIBbw&s",
      },
      {
        id: 7,
        title: " Sprint Planning",
        description: "Planning the tasks for the next sprint.",
        date: "12",
        month: "9",
        time: "10:00 AM",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPZn1sXyLc8pG_Jvbc9iS4TG7eNINybeeg&s",
      },
    ],
  },
];
